/**
 * Created by Ning Jiang on 12/11/2017.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TweenLite, Bounce} from "gsap";

enum IndicatorTexture {
    M1 = "feature_K",
    M2 = "feature_Q",
    M3 = "feature_J"
}

export class RandomFeatureIndicatorView extends BaseView {

    private _layer:ScalableLayer;
    private _indicator:PIXI.Sprite;
    private _isShowing:boolean = false;
    private _isDirty:boolean = false;

    constructor() {
        super();

        this._layer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.FEATURE_INDICATOR.name);
    }

    protected initAnimations():void {
        this._indicator = new PIXI.Sprite();
        this._indicator.alpha = 0;
        this._layer.addChild(this._indicator);
    }

    public showIndicator(featureSymbol:string):void {
        this._isShowing = true;

        const textureName:string = (<any>IndicatorTexture)[featureSymbol];
        this._indicator.texture = GameResources.getTextures(textureName)[0];

        if(this._isDirty) {
            this.onResize(this._resizeData);
        } else {
            this.show();
        }
    }

    private show():void {
        TweenLite.fromTo(this._indicator, 1.5, {alpha : 0, ease: Bounce.easeOut}, {alpha : 1});
    }

    public hideIndicator():void {
        this._isShowing = false;
        TweenLite.to(this._indicator, 0.2, {alpha : 0});
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isShowing) {
            this._isDirty = true;
            return;
        }

        switch(resizeData.orientation) {
            case Orientation.LANDSCAPE:
                this._indicator.position.set(104, 415);
                break;
            case Orientation.PORTRAIT:
                this._indicator.position.set(892, -116);
                break;
            default:
                debugger;
                throw new Error(`Error: RandomFeatureIndicatorView.onResize() Illegal orientation!`);
        }

        this.show();
        this._isDirty = false;
    }
}